import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { PaymentProvider } from '../paymentprovider.model';
import { PaymentproviderService } from '../paymentprovider.service';

@Component({
  selector: 'app-paymentproviderlst',
  templateUrl: './paymentproviderlst.component.html',
  styleUrls: ['./paymentproviderlst.component.css'],
  queries: {
    contentRef: new ViewChild("Modal")
  },
})
export class PaymentproviderlstComponent implements OnInit {

  paymentProviders: PaymentProvider[] = [];
  displayedColumns: string[] = ['id', 'arabicName', 'englishName', "edit", "delete"];
  dataSource!: MatTableDataSource<PaymentProvider>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  paymentProvider: PaymentProvider = {} as PaymentProvider;
  Catgstatus: { id: number, name: string }[] = [];

  selectedStatus: number = 1;
  pageSize = 100;
  constructor(private service: PaymentproviderService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private localStorage: LocalStorageService,
    private globle: Globle,
    private translate: TranslateService) {
    var lang = this.localStorage.retrieve("lang");
    lang == 0 ? this.translate.use('en') : this.translate.use('ar');
  }

  ngOnInit() {
    this.Catgstatus = [{ id: 1, name: this.translate.instant("active") }, { id: 0, name: this.translate.instant("notActive") }];
    this.selectedStatus = 1;
    this.pageSize = this.globle.pageSize;
    this.getPaymentProviders();

  }


  getPaymentProviders() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedStatus).subscribe(data => {
      this.paymentProviders = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.paymentProviders);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  createNew() {
    this.router.navigate(['./master/cards/addpaymentproviders']);
  }

  edit(id: number) {
    this.router.navigate(['./master/cards/editpaymentproviders/' + id]);
  }

  onDelete(id: number) {
    this.paymentProvider.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.Delete(this.paymentProvider.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getPaymentProviders();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectChange() {
    this.getPaymentProviders();
  }

}
